import script from "./Error404.vue?vue&type=script&setup=true&lang=js"
export * from "./Error404.vue?vue&type=script&setup=true&lang=js"

import "./Error404.vue?vue&type=style&index=0&id=0892fb04&scoped=true&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0892fb04"]])

export default __exports__